module.exports = __webpack_public_path__ + "media/entities/1125-19bf16e0.png";